import * as React from "react"
import { TaxStatus } from "@digits-graphql/frontend/graphql-bearer"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgCheckVerified02 } from "@digits-shared/components/SVGIcons/line/CheckVerified02.svg"
import { SvgQuestionVerified } from "@digits-shared/components/SVGIcons/line/QuestionVerified.svg"
import { SvgXVerified } from "@digits-shared/components/SVGIcons/line/XVerified.svg"
import { Select, SelectItem } from "@digits-shared/DesignSystem/FormElements/Selects/Select"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { BULK_FIELD_WIDTH } from "src/frontend/components/OS/Applications/Shared/Accounting/BulkActions/types"

const StyledSelect = styled(Select)`
  width: ${BULK_FIELD_WIDTH}px;
`

const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const QualifiedIcon = styled(SvgCheckVerified02)`
  width: 18px;
  height: 18px;
  ${svgPathStyles(colors.accentBlue, 1.5)};
`

const UnqualifiedIcon = styled(SvgXVerified)`
  width: 18px;
  height: 18px;
  ${svgPathStyles(colors.secondary30, 1.5)};
`

const UnknownIcon = styled(SvgQuestionVerified)`
  width: 18px;
  height: 18px;
  ${svgPathStyles(colors.secondary70, 1.5)};
`

export const TaxStatusSelect: React.FC<{
  status: TaxStatus | undefined
  setStatus: (status: TaxStatus) => void
  placeholder: string | undefined
  disabled: boolean
  customLabel?: string
}> = ({ status, setStatus, placeholder, disabled, customLabel }) => (
  <StyledSelect
    id="bulk-update-tax-status-select"
    name="bulk-update-tax-status-select"
    value={status}
    onValueChange={setStatus}
    placeholder={placeholder}
    disabled={disabled}
    label={customLabel ? customLabel : "1099 Qualification"}
    small
  >
    <SelectItem value={TaxStatus.Taxable}>
      <StatusInfo>
        <QualifiedIcon />
        1099 Qualified
      </StatusInfo>
    </SelectItem>

    <SelectItem value={TaxStatus.NonTaxable}>
      <StatusInfo>
        <UnqualifiedIcon />
        1099 Unqualified
      </StatusInfo>
    </SelectItem>

    <SelectItem value={TaxStatus.Undetermined}>
      <StatusInfo>
        <UnknownIcon />
        Unknown
      </StatusInfo>
    </SelectItem>
  </StyledSelect>
)
